/**
 * En logout, el dispositivo deja de recibir push del usuario saliente:
 * teléfono compartido = usuario B no debe recibir avisos de usuario A.
 * Best-effort: jamás bloquea el logout.
 */

import { api } from "../lib/api";

export async function removePushSubscriptionOnLogout(
  token: string | null,
): Promise<void> {
  try {
    if (!token || !("serviceWorker" in navigator)) return;
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) return;
    const subscription = await registration.pushManager.getSubscription();
    if (!subscription) return;
    const endpoint = subscription.endpoint;
    await subscription.unsubscribe().catch(() => {});
    await api.push.unsubscribe(token, endpoint).catch(() => {});
  } catch {
    // best-effort
  }
}
